/**
 * PermissionDenied — the permission-denied panel shown when an operator without
 * Owner/Admin reaches a Configuration screen (the design's permission-denied
 * state, handoff `12-permission-denied.png`).
 *
 * Adapted from the handoff reference (`mui_conversion/ConfigDenied.tsx`) to our
 * conventions: the reference copy referenced the prototype's demo role-switcher
 * ("switch the role selector top right"), which we intentionally do NOT build —
 * production role comes from the JWT — so that sentence is dropped.
 *
 * Forward-compatible: today every authenticated operator is OWNER/ADMIN, so this
 * panel is inert in practice, but the gate is wired correctly regardless (see
 * `RequireAdmin`).
 */
import { Alert, AlertTitle, Box } from '@mui/material';
import { Icon } from '@/theme';

export function PermissionDenied() {
  return (
    <Box sx={{ mt: 2.5, maxWidth: 620 }}>
      <Alert severity="error" icon={<Icon name="block" sx={{ fontSize: 22 }} />}>
        <AlertTitle sx={{ fontWeight: 500 }}>Owner or Admin access required</AlertTitle>
        Configuration changes affect billing, integrations and policies for the
        whole location, so they&rsquo;re limited to Owner and Admin roles.
      </Alert>
    </Box>
  );
}
